import { escapeAttr } from "./escape.js";
/**
 * URL is treated as external when it points off-origin: absolute http(s)://,
 * protocol-relative //, or mailto:/tel:/javascript: schemes. Anything else
 * (relative paths, root-relative /paths, #anchors, empty) is internal.
 */
export function isExternalUrl(href) {
    if (!href)
        return false;
    return /^(https?:)?\/\//i.test(href) || /^(mailto:|tel:|javascript:)/i.test(href);
}
/**
 * Renders the safe attribute set for an `<a>` tag given an href and optional target.
 *
 * Returns a leading-space-prefixed string ready to interpolate immediately after
 * the href attribute, e.g. `<a href="${escapeAttr(href)}"${linkAttrs(href, target)}>`.
 *
 * Why: `target="_blank"` without `rel="noopener noreferrer"` lets the linked page
 * call `window.opener.location = ...` to phish the user. Browsers added implicit
 * `noopener` for new tabs in 2021, but defense-in-depth: emit it explicitly.
 * For external hrefs without an explicit target we also emit `rel="noopener
 * noreferrer"` so a user opening the link with cmd-click / middle-click stays safe.
 */
export function linkAttrs(href, target) {
    const parts = [];
    if (target) {
        parts.push(`target="${escapeAttr(target)}"`);
    }
    const needsRel = target === "_blank" || (!target && isExternalUrl(href));
    if (needsRel) {
        parts.push('rel="noopener noreferrer"');
    }
    return parts.length ? ` ${parts.join(" ")}` : "";
}
//# sourceMappingURL=link.js.map